export default __webpack_public_path__ + "img/b98a115e88a7e9f678c544a7a80e2de2.svg";